import styled from "styled-components";

import { TEXT_PRIMARY, WHITE } from "@/constants/colors";
import { BODY, REGULAR } from "@/constants/fonts";

export const TooltipWrap = styled.div`
  position: relative;
  display: inline-block;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: fit-content;
  text-decoration: none !important;
  &:hover {
    > div {
      visibility: visible;
    }
  }
`;

export const TooltipBody = styled.div`
  position: absolute;
  visibility: hidden;
  text-align: center;

  height: ${({ height }) => `${height}` || "fit-content"};
  width: ${({ width }) => `${width}` || "fit-content"};
  padding: 1rem;
  font-size: 12px;
  letter-spacing: 0;
  font-family: ${BODY};
  font-weight: ${REGULAR};
  color: ${TEXT_PRIMARY};
  background-color: ${({ variant }) =>
    variant === "info" ? WHITE : variant === "warn" ? "#fff0f5" : `#FFF0F5`};
  box-shadow:
    0px 3px 7px 2px rgba(0, 0, 0, 0.1),
    0px 1px 2px 1px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  justify-content: center;
  align-items: center;
  z-index: 1;

  ${({ width }) => !width && "white-space: nowrap;"}

  ${({ bottom, right, left }) =>
    bottom
      ? `
      left: 50%;
      transform: translateX(-50%);
      top: 150%;
    `
      : right
      ? `
      left: 175%;
      transform: translateY(-50%);
      top: 50%;
    `
      : left
      ? `
      right: 120%;
      transform: translateY(-50%);
      top: 50%;
    `
      : `
      top: 0;
      left: 50%;
    `}

  &:after {
    content: "";
    ${({ bottom, right, left, variant }) =>
      bottom
        ? `
        left: 50%;
        transform: translateX(-50%);
        bottom: 100%;
        border-color: transparent transparent ${
          variant === "info" ? WHITE : variant === "warn" ? "#fff0f5" : `#FFF0F5`
        }
      transparent;
    `
        : right
        ? `
      right: 100%;
      top: 50%;
      transform: translateY(-50%);
      border-color: transparent ${
        variant === "info" ? WHITE : variant === "warn" ? "#fff0f5" : `#FFF0F5`
      } transparent transparent;
    `
        : left
        ? `
      left: 96%;
      top: 50%;
      box-shadow: -4px 4px 5px 0px rgba(0, 0, 0, 0.1);
      z-index: -1;
      transform: translateY(-50%) scaleX(-1) rotate(45deg);
      border-color: ${
        variant === "info" ? WHITE : variant === "warn" ? "#fff0f5" : `#FFF0F5`
      };
    `
        : `
      top: 0;
      left: 50%;
      border-color: ${
        variant === "info" ? WHITE : variant === "warn" ? "#fff0f5" : `#FFF0F5`
      }
      transparent transparent transparent;
    `}

    position: absolute;
    border-width: 8px;
    border-style: solid;
  }
`;
